import { requestType } from "~/config/enum.config";
var SERVICE = "domain-service";
var CONTROLLER = "turnRecordController";
/**
 * 流转记录控制器
 */
export default {
    /**
     * 分页获取流转记录
     */
    findTurnRecordDetailPage: {
        service: SERVICE,
        controller: CONTROLLER,
        action: "findTurnRecordDetailPage",
        type: requestType.Get
    },
    /**
     * 案件流转查询
     */
    findAllTurnRecord: {
        service: SERVICE,
        controller: CONTROLLER,
        action: "findAllTurnRecord",
        type: requestType.Get
    }
};
